"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdentityContextProvider = exports.handleRefreshTokenResponse = exports.updateIdentity = exports.CurrentIdentity = exports.useIdentity = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const _1 = require(".");
const IdentityContext = React.createContext(undefined);
function useIdentity() {
    const context = (0, react_1.useContext)(IdentityContext);
    if (!context) {
        throw new Error('Identity Context is unavailble');
    }
    return Object.assign(Object.assign({}, context), { accessToken: context.getAccessToken() });
}
exports.useIdentity = useIdentity;
function updateIdentity(identity) {
    exports.CurrentIdentity = identity;
    return identity;
}
exports.updateIdentity = updateIdentity;
function handleRefreshTokenResponse(result, history, force) {
    return __awaiter(this, void 0, void 0, function* () {
        if (result.redirect_url) {
            // we need to request this redirect as it will initialise the identity server login
            const p = (0, _1.getExtensionPage)(window.location.pathname.split('/')[1]);
            if (!p.anonymous || force) {
                try {
                    const res = yield fetch(result.redirect_url, { redirect: 'error', headers: { 'x-redirect-as-content': '1' } });
                    if (!res.ok)
                        throw new Error(`soft-redirect to ${result.redirect_url} failed`);
                    const path = yield res.text();
                    console.log('redirecting to login page', path);
                    history.replace(path);
                }
                catch (e) {
                    console.log('error in handlerefresh', e);
                    // if the redirect happens, we will just redirect directly
                    window.location.href = result.redirect_url;
                }
            }
            // window.location.href = result.redirect_url;
            return false;
        }
        if (result.accessToken) {
            exports.CurrentIdentity = result;
            return true;
        }
    });
}
exports.handleRefreshTokenResponse = handleRefreshTokenResponse;
function IdentityContextProvider({ refreshToken, initialToken, children }) {
    exports.CurrentIdentity = initialToken;
    const errorCount = (0, react_1.useRef)(0);
    const history = (0, react_router_dom_1.useHistory)();
    const identity = exports.CurrentIdentity;
    // if (!identity) {
    // 	return (
    // 		<div style={{ width: '100vw', height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
    // 			<div>
    // 				<Extension name="shell.splash-logo" />
    // 				<h1 style={{ textAlign: 'center', margin: 0, padding: '10px', fontFamily: 'Roboto, san-serif', color: 'white' }}>
    // 					Authenticating...
    // 				</h1>
    // 			</div>
    // 		</div>
    // 	);
    // }
    (0, react_1.useEffect)(() => {
        handleRefreshTokenResponse(initialToken, history);
    }, [initialToken]);
    function ensureAuthenticated() {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield refreshToken();
            // an error could occur because of a network change (happens often with resuming from sleep)
            if (result.error) {
                errorCount.current++;
                // we should actually look at the expiry of the token and upon failure to refresh where
                // the current access token is now expired we could do this. As it is we are assuming
                // 30 minutes have elapsed, and the default token life is 60 minutes, so this should be
                // a safe assumption
                if (errorCount.current > 3) {
                    // 5 failures
                    alert('There has been an error with your session and we need to reload');
                    window.location.reload();
                }
                return;
            }
            errorCount.current = 0;
            handleRefreshTokenResponse(result, history);
            //alert('Refresh failed - token might have expired. Should redirect but we weren\'t given a redirect url');
            return false;
        });
    }
    // ensure we refresh the token regularly
    React.useEffect(() => {
        if (!refreshToken)
            return;
        // every 10 minutes we refresh the token
        const interval = setInterval(ensureAuthenticated, 1000 * 60 * 10);
        return () => clearInterval(interval);
    }, []);
    const id = typeof identity === 'boolean' ? { ok: false } : identity;
    return (React.createElement(IdentityContext.Provider, { value: Object.assign(Object.assign({}, id), { authorized: id && id.user && !!id.user.t, ensureAuthenticated, getAccessToken: _1.api.getAccessToken }) }, children));
}
exports.IdentityContextProvider = IdentityContextProvider;
